/*
window.addEventListener("dx_init", function(){  
    dx_accordions_init();
});
*/
if(window.parent==window){
    window.addEventListener("load", function(){
         dx_accordions_init();
    });     
}
window.addEventListener("dx_accordion_init", function(event){ 
    dx_accordion_init(event.detail.block);
});

function dx_accordions_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-accordion"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_accordion_init(blocks[i]);               
    }   
}    

function dx_accordion_init(block){
    if(block.getAttribute("data-init")=="1"){
        return;
    }
    block.setAttribute("data-init", "1");

    block.setAttribute("data-opened", 0);
    const items= block.getElementsByClassName("wp-block-dx-accordion-item"); 
    for(let i = 0; i<items.length; i++){
        const wrapper = items[i].getElementsByClassName("wp-block-dx-accordion-item-wrapper")[0]; 
        wrapper.style.height="0px"; 
        items[i].setAttribute("data-id", i);
        items[i].setAttribute("data-opened", 0);
        const head = items[i].getElementsByClassName("wp-block-dx-accordion-item-head")[0];
        head.addEventListener("click", (event)=>{                
            const block = event.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode;          
            dx_accordion_open(block, event.currentTarget.parentNode.parentNode.getAttribute("data-id"));
        })
    }
    dx_accordion_open(block, 0); 
}

function dx_accordion_open(block, id){
    block.setAttribute("data-opened", id);
    const items= block.getElementsByClassName("wp-block-dx-accordion-item"); 
    const transitionTime = 0.3;
    for(let i = 0; i<items.length; i++){
        const wrapper = items[i].getElementsByClassName("wp-block-dx-accordion-item-wrapper")[0];  
        if(items[i].getAttribute("data-id") == block.getAttribute("data-opened")){ 
            items[i].setAttribute("data-opened", 1);
            setTimeout(()=>{
                wrapper.style.transition="height "+transitionTime+"s linear"; 
                wrapper.style.height=wrapper.getElementsByClassName("wp-block-dx-accordion-item-innerblocks")[0].offsetHeight+"px";
            } , 1);   
            setTimeout(()=>{
                wrapper.style.height="auto";
            }, transitionTime*1000);
        } else {  
            items[i].setAttribute("data-opened", 0); 
            if(wrapper.style.height!="0px"){
                wrapper.style.transition="none";
                wrapper.style.height=wrapper.getElementsByClassName("wp-block-dx-accordion-item-innerblocks")[0].offsetHeight+"px";
                setTimeout(()=>{
                    wrapper.style.transition="height "+transitionTime+"s linear"; 
                    wrapper.style.height="0px";
                }, 1);
            }
        }
    }    
}

function dx_accordions_update(){
    var blocks = document.getElementsByClassName("wp-block-dx-accordion"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_accordion_update(blocks[i]);               
    }  
}   

function dx_accordion_update(block){
    
}
  
